import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card shadow-sm" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "badge bg-secondary" }
const _hoisted_4 = { class: "card-body p-0" }
const _hoisted_5 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_6 = {
  key: 1,
  class: "text-center py-5 text-muted"
}
const _hoisted_7 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_8 = {
  class: "table table-hover align-middle mb-0",
  style: {"table-layout":"fixed","min-width":"1150px"}
}
const _hoisted_9 = { class: "table-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForexAlertRow = _resolveComponent("ForexAlertRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "mb-0" }, "Alertas del Periodo", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.alerts.length) + " alertas", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Cargando...")
            ], -1)
          ]))]))
        : (_ctx.alerts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fas fa-inbox fa-3x mb-3" }, null, -1),
              _createElementVNode("p", null, "No hay alertas en el periodo seleccionado.", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", _hoisted_9, [
                  _createElementVNode("tr", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("th", {
                      style: {"width":"30px"},
                      "aria-label": "Expandir/Colapsar"
                    }, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("th", {
                      style: {"width":"90px"},
                      class: "text-center text-nowrap"
                    }, " # ", -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("th", {
                      style: {"width":"130px"},
                      class: "text-center text-nowrap"
                    }, " Fecha ", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("th", {
                      class: "text-nowrap",
                      style: {"min-width":"150px"}
                    }, " Contenido ", -1)),
                    _createElementVNode("th", {
                      style: _normalizeStyle({
                  width: _ctx.alertType === _ctx.AlertType.FOREX ? '100px' : '150px',
                }),
                      class: "text-center text-nowrap"
                    }, _toDisplayString(_ctx.alertType === _ctx.AlertType.FOREX ? "Par" : "Índice"), 5),
                    _cache[12] || (_cache[12] = _createElementVNode("th", {
                      style: {"width":"100px"},
                      class: "text-center text-nowrap"
                    }, " Tipo ", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("th", {
                      style: {"width":"100px"},
                      class: "text-center text-nowrap"
                    }, " Dirección ", -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("th", {
                      style: {"width":"85px"},
                      class: "text-center text-nowrap"
                    }, " PE ", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("th", {
                      style: {"width":"85px"},
                      class: "text-center text-nowrap"
                    }, " TP ", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("th", {
                      style: {"width":"85px"},
                      class: "text-center text-nowrap"
                    }, " SL ", -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("th", {
                      style: {"width":"110px"},
                      class: "text-center text-nowrap"
                    }, " Resultado ", -1)),
                    _cache[18] || (_cache[18] = _createElementVNode("th", {
                      style: {"width":"100px"},
                      class: "text-center text-nowrap"
                    }, " Estado ", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert, index) => {
                    return (_openBlock(), _createBlock(_component_ForexAlertRow, {
                      key: alert.alertId,
                      alert: alert,
                      "row-number": _ctx.alerts.length - index,
                      "alert-type": _ctx.alertType,
                      "expanded-alert-id": _ctx.expandedAlertId,
                      "editing-alert-id": _ctx.editingAlertId,
                      "is-saving": _ctx.isSaving,
                      "is-reprocessing": _ctx.isReprocessing,
                      onToggleExpand: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-expand', $event))),
                      onStartEdit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('start-edit', $event))),
                      onCancelEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancel-edit'))),
                      onSaveEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('save-edit', $event))),
                      onReprocessMessage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reprocess-message', $event)))
                    }, null, 8, ["alert", "row-number", "alert-type", "expanded-alert-id", "editing-alert-id", "is-saving", "is-reprocessing"]))
                  }), 128))
                ])
              ])
            ]))
    ])
  ]))
}